<template>
  <div class="cover">
    <div v-if="isLoading" class="loading">
      <span style="margin-right: 5px">loading</span>
      <i
        style="font-size: 18px"
        class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"
      ></i>
    </div>
    <div class="title-info">
      <!-- <p class="text">{{ name }}</p> -->
      <!-- <p class="desc">{{ desc }}</p> -->
    </div>
    <div v-if="items && items.length > 0" class="grid">
      <div
        v-for="item in items"
        :key="item.name"
        @click="enableSetting(item.action)"
        class="item"
      >
        <el-tooltip
          v-if="item.desc"
          class
          effect="dark"
          :content="item.desc || ''"
          placement="bottom"
        >
          <div>{{ item.name }}</div>
        </el-tooltip>
        <span v-if="!item.desc">{{ item.name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Switch, Notification, Tooltip } from "element-ui";

export default {
  name: "ElementControlRadio",
  props: {
    name: "",
    desc: "",
    items: null
  },
  components: {
    "el-form": Switch,
    "el-tooltip": Tooltip
  },
  data() {
    return {
      isLoading: false
    };
  },
  watch: {
    defaultValue: {}
  },
  methods: {
    enableSetting(action) {
      if (!this.showConfirm()) return;
      this.sendRequest(action);
    },

    sendRequest(action) {
      var requestParam = {
        topic: this.$route.params.deviceId,
        payload: JSON.stringify({
          invConfig: action
        })
      };

      const HTTP = this.$httpUtils.instance;

      this.showLoading(true);
      HTTP.options(
        `${this.$utilConstants.IOT_BASE_URL}/event/publish/`,
        requestParam
      )
        .then(response => {
          this.$emit("refresh");
          this.showAlarm({ type: "success", message: "Success, sent!" });
          this.showLoading(false);
        })
        .catch(e => {
          this.showAlarm({
            type: "error",
            message: "Error, unable to complete action, please try again"
          });
          this.showLoading(false);
        });
    },
    showConfirm() {
      return confirm(`Are you sure you want to enable setting?`);
    },
    showLoading(value) {
      this.isLoading = value;
    },
    // @todo: this should be a global something
    showAlarm({ type, message }) {
      switch (type) {
        case "success":
          return Notification.success({
            title: "Success",
            dangerouslyUseHTMLString: true,
            message: message ? message : "Action completed successfully"
          });
        case "warning":
          return Notification.error({
            title: "Error",
            dangerouslyUseHTMLString: true,
            message: message
          });
        default:
          return Notification.warning({
            title: "Unknown",
            dangerouslyUseHTMLString: true,
            message: message ? message : "unknown, please verify"
          });
      }
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.cover {
  position: relative;
}

.grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}
.el-tooltip-width {
  width: inherit;
}
.item {
  border: 1px solid #f4f4f4;
  padding: 12px;
  border-radius: 12px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
  background-color: #ffffff;
  width: inherit;
}

.title-info {
  margin-bottom: 20px;
}

.text {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 0;
  line-height: normal;
}

.desc {
  color: #999;
}

.loading {
  display: flex;
  text-align: center;
  background: #ffffffe6;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  align-items: center;
  justify-content: center;
}

.bottom {
  clear: both;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/performance/controls/element-control-radio.vue